export const API_URL='https://forkify-api.jonas.io/api/v2/recipes';
export const API_KEY='b6c735f6-766b-4704-8b4b-b66aba530b25';
//export const API_URL='https://api.spoonacular.com/recipes';
//export const API_KEY='a1a96579a2084e5d983e9d6744b89602';
